import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, setSelectedBusiness, useGetBusinessByIdQuery } from '../store';

const useGetSelectedBusiness = () => {
  const dispatch = useDispatch();
  const { business_id: businessId } = useParams<{ business_id: string }>();
  const selectedBusiness = useSelector((state: RootState) => state.businesses.business);
  const differentSelected = selectedBusiness?.id !== businessId;
  const { data: business, isLoading: businessLoading } = useGetBusinessByIdQuery(businessId ?? '', { skip: !businessId || (!!selectedBusiness && !differentSelected) });
  if (business && !selectedBusiness) {
    dispatch(setSelectedBusiness(business));
  }
  return { business: business || selectedBusiness, businessLoading };
};

export default useGetSelectedBusiness;
